/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {StateDeclarationBuilder, AdnRouterHelperApi} from '../routing/state-utils';
import {stateTitleView} from '../common/directives/html/state-title.component';
import {PaymentRoutePageComponent} from './payment-route-page.component';
import {emptyRouteView} from '../common/directives/html/route-view-components';


export function paymentStates(_adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  const states = new StateDeclarationBuilder();
states.add('app.rep.payments', {
          url: '/payments',
          views: {
            'content@app': {
              component: PaymentRoutePageComponent
            },
            'context@app': emptyRouteView(),
            'title@app': stateTitleView()
          },
          data: {
            title: "payment.plural"
          }
        });
  return states.build();
}